export const isDev = () => {
  return window.location.host.includes("dev") ||
    window.location.host.includes("localhost")
    ? true
    : false;
};
